const typography = {
  fontFamily: ['"Open Sans", sans-serif'],
  fontSize: 12,
  fontWeight: 0,
  h1: {
    fontSize: '42px'
  },
  h2: {
    fontSize: '32px'
  },
  h3: {
    fontSize: '26px'
  },
  h4: {
    fontSize: '20px'
  },
  h5: {
    fontSize: '16px'
  },
  h6: {
    fontSize: '14px'
  },
  subtitle1: {
    fontSize: '26px'
  },
  subtitle2: {
    fontSize: '9px'
  },
  body1: {
    fontSize: '12px'
  }
}

export default typography
